import React, {Component} from 'react';
import {connect} from 'react-redux';
import { inject, observer } from 'mobx-react';

class FormInput extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderInner()
  {
    if(this.props.type==='checkbox') {
      if(this.props.mode === 'row') {
        return (

          <div className="up12 margin">
            <div className="cell s-12 m-3">
              <div className="dotted1-bottom pbottom5 bo-w3">
                {this.props.title}
              </div>
            </div>
            <div className="cell s-12 m-9">
              {this.props.secondColumn?(
                <div className="up12 margin">
                  <div className="cell s-6">
                    <label>
                      {this.props.children}<span></span>
                    </label>
                  </div>
                  <div className="cell s-6">
                    {this.props.secondColumn}
                  </div>
                </div>
              ):(
                <label className="db">
                  <label>
                    {this.props.children}<span></span>
                  </label>
                </label>
              )}

              {this.props.description ? (
                <div className="ptop5 fs13 sc1">
                  {this.props.description}
                </div>
              ) : null}
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <label>
              <div className="up12 splice">
                <div className="cell s-shrink">
                  {this.props.children}<span></span>
                </div>
                <div className="cell s-auto pleft10">
                  {this.props.title}
                </div>
              </div>
            </label>
          </div>
        )
      }
    } else {
      if(this.props.mode === 'row') {
        return (
          <div className="up12 margin">
            <div className="cell s-12 m-3 pbottom20">
              <div className="dotted1-bottom pbottom5 bo-w3">
                {this.props.title}
              </div>
            </div>
            <div className="cell s-12 m-9 pbottom20">


                <div className="up12 margin">
                  <div className={`cell ${this.props.secondColumn?'s-6':'s-12'}`}>
                    {this.props.children}
                  </div>
                  <div className={`cell ${this.props.secondColumn?'s-6':'dn'}`}>
                    {this.props.secondColumn}
                  </div>
                </div>



              {this.props.description ? (
                <div className="ptop5 fs13 sc1">
                  {this.props.description}
                </div>
              ) : null}
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <div className="pbottom5">{this.props.title}</div>
            {this.props.children}
          </div>
        );
      }
    }
  }
  render() {
    return (
      <div className="pbottom20">
        {this.renderInner()}
        {!this.props.mode?(<>
          {this.props.description ? (
            <div className="ptop5 fs13 sc1">
              {this.props.description}
            </div>
          ) : null}
        </>):null}
      </div>
    )
  }
}

function mapStateToProps(state) {
    return {}
}

export default observer(FormInput);
